import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from '@/features/auth/store';

const MainLayout = React.lazy(() => import('@/layouts/MainLayout'));
const LoginPage = React.lazy(() => import('@/features/auth/LoginPage'));

const Loading = () => (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse" />
    </div>
);

const App: React.FC = () => {
    const user = useAuthStore((s) => s.user);

    return (
        <BrowserRouter>
            <Toaster position="top-right" />
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
                    <Route path="/*" element={user ? <MainLayout /> : <Navigate to="/login" replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default App;
